// Données géographiques de la République Démocratique du Congo
export const rdcGeography = {
  'Kinshasa': {
    territories: ['Kinshasa'],
    sectors: {
      'Kinshasa': ['Lemba', 'Matete', 'Bumbu', 'Kalamu', 'Kasa-Vubu', 'Lingwala', 'Barumbu', 'Gombe', 'Kinshasa', 'Ngaliema', 'Limete', 'Kinshasa', 'Ndjili', 'Kimbanseke', 'Maluku', 'Masina', 'Nsele', 'Mont-Ngafula']
    }
  },
  'Kongo-Central': {
    territories: ['Boma', 'Kasangulu', 'Kimpese', 'Lukula', 'Matadi', 'Mbanza-Ngungu', 'Moanda', 'Seke-Banza', 'Songololo', 'Tshela'],
    sectors: {
      'Boma': ['Boma', 'Kisundi', 'Lukula', 'Mbanza-Ngungu'],
      'Kasangulu': ['Kasangulu', 'Kimpese', 'Lukula'],
      'Kimpese': ['Kimpese', 'Kasangulu'],
      'Lukula': ['Lukula', 'Boma'],
      'Matadi': ['Matadi', 'Boma', 'Kisundi'],
      'Mbanza-Ngungu': ['Mbanza-Ngungu', 'Boma', 'Lukula'],
      'Moanda': ['Moanda', 'Boma'],
      'Seke-Banza': ['Seke-Banza', 'Boma'],
      'Songololo': ['Songololo', 'Kimpese'],
      'Tshela': ['Tshela', 'Boma']
    }
  },
  'Kwango': {
    territories: ['Feshi', 'Kahemba', 'Kasongo-Lunda', 'Kenge', 'Popokabaka'],
    sectors: {
      'Feshi': ['Feshi', 'Kahemba', 'Kasongo-Lunda'],
      'Kahemba': ['Kahemba', 'Feshi', 'Kasongo-Lunda'],
      'Kasongo-Lunda': ['Kasongo-Lunda', 'Feshi', 'Kahemba'],
      'Kenge': ['Kenge', 'Popokabaka'],
      'Popokabaka': ['Popokabaka', 'Kenge']
    }
  },
  'Kwilu': {
    territories: ['Bagata', 'Bulungu', 'Gungu', 'Idiofa', 'Masi-Manimba'],
    sectors: {
      'Bagata': ['Bagata', 'Bulungu', 'Gungu'],
      'Bulungu': ['Bulungu', 'Bagata', 'Gungu'],
      'Gungu': ['Gungu', 'Bagata', 'Bulungu'],
      'Idiofa': ['Idiofa', 'Masi-Manimba'],
      'Masi-Manimba': ['Masi-Manimba', 'Idiofa']
    }
  },
  'Mai-Ndombe': {
    territories: ['Inongo', 'Kiri', 'Kutu', 'Oshwe'],
    sectors: {
      'Inongo': ['Inongo', 'Kiri', 'Kutu'],
      'Kiri': ['Kiri', 'Inongo', 'Kutu'],
      'Kutu': ['Kutu', 'Inongo', 'Kiri'],
      'Oshwe': ['Oshwe', 'Inongo']
    }
  },
  'Équateur': {
    territories: ['Bikoro', 'Bolomba', 'Bomongo', 'Bumba', 'Lukolela', 'Makanza', 'Mbandaka'],
    sectors: {
      'Bikoro': ['Bikoro', 'Bolomba', 'Bomongo'],
      'Bolomba': ['Bolomba', 'Bikoro', 'Bomongo'],
      'Bomongo': ['Bomongo', 'Bikoro', 'Bolomba'],
      'Bumba': ['Bumba', 'Lukolela', 'Makanza'],
      'Lukolela': ['Lukolela', 'Bumba', 'Makanza'],
      'Makanza': ['Makanza', 'Bumba', 'Lukolela'],
      'Mbandaka': ['Mbandaka', 'Bikoro', 'Bolomba']
    }
  },
  'Mongala': {
    territories: ['Bongandanga', 'Bumba', 'Lisala'],
    sectors: {
      'Bongandanga': ['Bongandanga', 'Bumba', 'Lisala'],
      'Bumba': ['Bumba', 'Bongandanga', 'Lisala'],
      'Lisala': ['Lisala', 'Bongandanga', 'Bumba']
    }
  },
  'Nord-Ubangi': {
    territories: ['Bosobolo', 'Businga', 'Gbadolite', 'Mobayi-Mbongo'],
    sectors: {
      'Bosobolo': ['Bosobolo', 'Businga', 'Gbadolite'],
      'Businga': ['Businga', 'Bosobolo', 'Gbadolite'],
      'Gbadolite': ['Gbadolite', 'Bosobolo', 'Businga'],
      'Mobayi-Mbongo': ['Mobayi-Mbongo', 'Gbadolite']
    }
  },
  'Sud-Ubangi': {
    territories: ['Bomongo', 'Budjala', 'Gemena', 'Libenge', 'Zongo'],
    sectors: {
      'Bomongo': ['Bomongo', 'Budjala', 'Gemena'],
      'Budjala': ['Budjala', 'Bomongo', 'Gemena'],
      'Gemena': ['Gemena', 'Bomongo', 'Budjala'],
      'Libenge': ['Libenge', 'Zongo'],
      'Zongo': ['Zongo', 'Libenge']
    }
  },
  'Tshuapa': {
    territories: ['Befale', 'Bokungu', 'Bomongo', 'Boende', 'Djolu', 'Ikela', 'Monkoto'],
    sectors: {
      'Befale': ['Befale', 'Bokungu', 'Bomongo'],
      'Bokungu': ['Bokungu', 'Befale', 'Bomongo'],
      'Bomongo': ['Bomongo', 'Befale', 'Bokungu'],
      'Boende': ['Boende', 'Djolu', 'Ikela'],
      'Djolu': ['Djolu', 'Boende', 'Ikela'],
      'Ikela': ['Ikela', 'Boende', 'Djolu'],
      'Monkoto': ['Monkoto', 'Boende']
    }
  },
  'Haut-Katanga': {
    territories: ['Kambove', 'Kipushi', 'Kisenge', 'Kipushi', 'Lubumbashi', 'Pweto', 'Sakania'],
    sectors: {
      'Kambove': ['Kambove', 'Kipushi', 'Kisenge'],
      'Kipushi': ['Kipushi', 'Kambove', 'Kisenge'],
      'Kisenge': ['Kisenge', 'Kambove', 'Kipushi'],
      'Lubumbashi': ['Lubumbashi', 'Kambove', 'Kipushi'],
      'Pweto': ['Pweto', 'Sakania'],
      'Sakania': ['Sakania', 'Pweto']
    }
  },
  'Haut-Lomami': {
    territories: ['Bukama', 'Kamina', 'Kambove', 'Kipushi', 'Malemba-Nkulu'],
    sectors: {
      'Bukama': ['Bukama', 'Kamina', 'Kambove'],
      'Kamina': ['Kamina', 'Bukama', 'Kambove'],
      'Kambove': ['Kambove', 'Bukama', 'Kamina'],
      'Kipushi': ['Kipushi', 'Malemba-Nkulu'],
      'Malemba-Nkulu': ['Malemba-Nkulu', 'Kipushi']
    }
  },
  'Lualaba': {
    territories: ['Dilolo', 'Kapanga', 'Kazumba', 'Kolwezi', 'Lubudi', 'Mutshatsha'],
    sectors: {
      'Dilolo': ['Dilolo', 'Kapanga', 'Kazumba'],
      'Kapanga': ['Kapanga', 'Dilolo', 'Kazumba'],
      'Kazumba': ['Kazumba', 'Dilolo', 'Kapanga'],
      'Kolwezi': ['Kolwezi', 'Lubudi', 'Mutshatsha'],
      'Lubudi': ['Lubudi', 'Kolwezi', 'Mutshatsha'],
      'Mutshatsha': ['Mutshatsha', 'Kolwezi', 'Lubudi']
    }
  },
  'Tanganyika': {
    territories: ['Kalemie', 'Kongolo', 'Manono', 'Moba', 'Nyunzu'],
    sectors: {
      'Kalemie': ['Kalemie', 'Kongolo', 'Manono'],
      'Kongolo': ['Kongolo', 'Kalemie', 'Manono'],
      'Manono': ['Manono', 'Kalemie', 'Kongolo'],
      'Moba': ['Moba', 'Nyunzu'],
      'Nyunzu': ['Nyunzu', 'Moba']
    }
  },
  'Ituri': {
    territories: ['Aru', 'Djugu', 'Irumu', 'Mahagi', 'Mambasa', 'Mongwalu'],
    sectors: {
      'Aru': ['Aru', 'Djugu', 'Irumu'],
      'Djugu': ['Djugu', 'Aru', 'Irumu'],
      'Irumu': ['Irumu', 'Aru', 'Djugu'],
      'Mahagi': ['Mahagi', 'Mambasa', 'Mongwalu'],
      'Mambasa': ['Mambasa', 'Mahagi', 'Mongwalu'],
      'Mongwalu': ['Mongwalu', 'Mahagi', 'Mambasa']
    }
  },
  'Haut-Uele': {
    territories: ['Bambesa', 'Bondo', 'Dungu', 'Faradje', 'Niangara', 'Rungu', 'Wamba'],
    sectors: {
      'Bambesa': ['Bambesa', 'Bondo', 'Dungu'],
      'Bondo': ['Bondo', 'Bambesa', 'Dungu'],
      'Dungu': ['Dungu', 'Bambesa', 'Bondo'],
      'Faradje': ['Faradje', 'Niangara', 'Rungu'],
      'Niangara': ['Niangara', 'Faradje', 'Rungu'],
      'Rungu': ['Rungu', 'Faradje', 'Niangara'],
      'Wamba': ['Wamba', 'Rungu']
    }
  },
  'Tshopo': {
    territories: ['Bafwasende', 'Basoko', 'Banalia', 'Isangi', 'Kisangani', 'Opala', 'Ubundu', 'Yahuma'],
    sectors: {
      'Bafwasende': ['Bafwasende', 'Basoko', 'Banalia'],
      'Basoko': ['Basoko', 'Bafwasende', 'Banalia'],
      'Banalia': ['Banalia', 'Bafwasende', 'Basoko'],
      'Isangi': ['Isangi', 'Kisangani', 'Opala'],
      'Kisangani': ['Kisangani', 'Isangi', 'Opala'],
      'Opala': ['Opala', 'Isangi', 'Kisangani'],
      'Ubundu': ['Ubundu', 'Yahuma'],
      'Yahuma': ['Yahuma', 'Ubundu']
    }
  },
  'Bas-Uele': {
    territories: ['Aketi', 'Ango', 'Bambesa', 'Bondo', 'Buta', 'Kisangani', 'Lubutu', 'Poko'],
    sectors: {
      'Aketi': ['Aketi', 'Ango', 'Bambesa'],
      'Ango': ['Ango', 'Aketi', 'Bambesa'],
      'Bambesa': ['Bambesa', 'Aketi', 'Ango'],
      'Bondo': ['Bondo', 'Buta', 'Kisangani'],
      'Buta': ['Buta', 'Bondo', 'Kisangani'],
      'Kisangani': ['Kisangani', 'Bondo', 'Buta'],
      'Lubutu': ['Lubutu', 'Poko'],
      'Poko': ['Poko', 'Lubutu']
    }
  },
  'Kasaï': {
    territories: ['Dekese', 'Ilebo', 'Kamonia', 'Luebo', 'Mweka'],
    sectors: {
      'Dekese': ['Dekese', 'Ilebo', 'Kamonia'],
      'Ilebo': ['Ilebo', 'Dekese', 'Kamonia'],
      'Kamonia': ['Kamonia', 'Dekese', 'Ilebo'],
      'Luebo': ['Luebo', 'Mweka'],
      'Mweka': ['Mweka', 'Luebo']
    }
  },
  'Kasaï-Central': {
    territories: ['Dibaya', 'Dimbelenge', 'Dimbelenge', 'Kazumba', 'Luebo', 'Mweka'],
    sectors: {
      'Dibaya': ['Dibaya', 'Dimbelenge', 'Kazumba'],
      'Dimbelenge': ['Dimbelenge', 'Dibaya', 'Kazumba'],
      'Kazumba': ['Kazumba', 'Dibaya', 'Dimbelenge'],
      'Luebo': ['Luebo', 'Mweka'],
      'Mweka': ['Mweka', 'Luebo']
    }
  },
  'Kasaï-Oriental': {
    territories: ['Kabinda', 'Katanda', 'Lomami', 'Lubao', 'Lukelenge', 'Miabi', 'Tshilenge'],
    sectors: {
      'Kabinda': ['Kabinda', 'Katanda', 'Lomami'],
      'Katanda': ['Katanda', 'Kabinda', 'Lomami'],
      'Lomami': ['Lomami', 'Kabinda', 'Katanda'],
      'Lubao': ['Lubao', 'Lukelenge', 'Miabi'],
      'Lukelenge': ['Lukelenge', 'Lubao', 'Miabi'],
      'Miabi': ['Miabi', 'Lubao', 'Lukelenge'],
      'Tshilenge': ['Tshilenge', 'Miabi']
    }
  },
  'Lomami': {
    territories: ['Kabinda', 'Katanda', 'Lomami', 'Lubao', 'Lukelenge', 'Miabi', 'Tshilenge'],
    sectors: {
      'Kabinda': ['Kabinda', 'Katanda', 'Lomami'],
      'Katanda': ['Katanda', 'Kabinda', 'Lomami'],
      'Lomami': ['Lomami', 'Kabinda', 'Katanda'],
      'Lubao': ['Lubao', 'Lukelenge', 'Miabi'],
      'Lukelenge': ['Lukelenge', 'Lubao', 'Miabi'],
      'Miabi': ['Miabi', 'Lubao', 'Lukelenge'],
      'Tshilenge': ['Tshilenge', 'Miabi']
    }
  },
  'Sankuru': {
    territories: ['Dekese', 'Kole', 'Lomela', 'Lusambo', 'Miabi', 'Tshilenge'],
    sectors: {
      'Dekese': ['Dekese', 'Kole', 'Lomela'],
      'Kole': ['Kole', 'Dekese', 'Lomela'],
      'Lomela': ['Lomela', 'Dekese', 'Kole'],
      'Lusambo': ['Lusambo', 'Miabi', 'Tshilenge'],
      'Miabi': ['Miabi', 'Lusambo', 'Tshilenge'],
      'Tshilenge': ['Tshilenge', 'Lusambo', 'Miabi']
    }
  },
  'Maniema': {
    territories: ['Kabambare', 'Kailo', 'Kasongo', 'Kibombo', 'Lubutu', 'Pangi', 'Punia'],
    sectors: {
      'Kabambare': ['Kabambare', 'Kailo', 'Kasongo'],
      'Kailo': ['Kailo', 'Kabambare', 'Kasongo'],
      'Kasongo': ['Kasongo', 'Kabambare', 'Kailo'],
      'Kibombo': ['Kibombo', 'Lubutu', 'Pangi'],
      'Lubutu': ['Lubutu', 'Kibombo', 'Pangi'],
      'Pangi': ['Pangi', 'Kibombo', 'Lubutu'],
      'Punia': ['Punia', 'Pangi']
    }
  },
  'Nord-Kivu': {
    territories: ['Beni', 'Butembo', 'Goma', 'Lubero', 'Masisi', 'Nyiragongo', 'Rutshuru', 'Walikale'],
    sectors: {
      'Beni': ['Beni', 'Butembo', 'Goma'],
      'Butembo': ['Butembo', 'Beni', 'Goma'],
      'Goma': ['Goma', 'Beni', 'Butembo'],
      'Lubero': ['Lubero', 'Masisi', 'Nyiragongo'],
      'Masisi': ['Masisi', 'Lubero', 'Nyiragongo'],
      'Nyiragongo': ['Nyiragongo', 'Lubero', 'Masisi'],
      'Rutshuru': ['Rutshuru', 'Walikale'],
      'Walikale': ['Walikale', 'Rutshuru']
    }
  },
  'Sud-Kivu': {
    territories: ['Bukavu', 'Fizi', 'Idjwi', 'Kabare', 'Kalehe', 'Miti-Mwamba', 'Mwenga', 'Shabunda', 'Uvira', 'Walungu'],
    sectors: {
      'Bukavu': ['Bukavu', 'Fizi', 'Idjwi'],
      'Fizi': ['Fizi', 'Bukavu', 'Idjwi'],
      'Idjwi': ['Idjwi', 'Bukavu', 'Fizi'],
      'Kabare': ['Kabare', 'Kalehe', 'Miti-Mwamba'],
      'Kalehe': ['Kalehe', 'Kabare', 'Miti-Mwamba'],
      'Miti-Mwamba': ['Miti-Mwamba', 'Kabare', 'Kalehe'],
      'Mwenga': ['Mwenga', 'Shabunda', 'Uvira'],
      'Shabunda': ['Shabunda', 'Mwenga', 'Uvira'],
      'Uvira': ['Uvira', 'Mwenga', 'Shabunda'],
      'Walungu': ['Walungu', 'Uvira']
    }
  }
};

// Fonction pour obtenir les territoires d'une province
export const getTerritoriesByProvince = (province) => {
  return rdcGeography[province]?.territories || [];
};

// Fonction pour obtenir les secteurs d'un territoire
export const getSectorsByTerritory = (province, territory) => {
  return rdcGeography[province]?.sectors?.[territory] || [];
};

// Fonction pour obtenir les chefs-lieux d'un secteur
export const getChiefTownsBySector = (province, territory, sector) => {
  const sectors = rdcGeography[province]?.sectors?.[territory] || [];
  return sectors.includes(sector) ? [sector] : [];
};

// Fonction pour obtenir toutes les provinces
export const getAllProvinces = () => {
  return Object.keys(rdcGeography);
};
